import { useState, useMemo, useRef, useEffect } from 'react';
import type { StoreFilterItem } from '@/components/ui/store-filter';

interface UseStoreFilterStateOptions {
  stores: { id: string; shortName: string }[];
}

export function useStoreFilterState({ stores }: UseStoreFilterStateOptions) {
  const [selectedStores, setSelectedStores] = useState<string[]>([]);
  const storesInitialized = useRef(false);

  const storeFilterItems: StoreFilterItem[] = useMemo(() => {
    return stores.map((s) => ({
      id: s.id,
      shortName: s.shortName,
    }));
  }, [stores]);

  // stores取得後に全店舗を選択（初回のみ）
  useEffect(() => {
    if (storeFilterItems.length > 0 && !storesInitialized.current) {
      storesInitialized.current = true;
      setSelectedStores(storeFilterItems.map((s) => s.shortName));
    }
  }, [storeFilterItems]);

  const toggleStore = (shortName: string) => {
    setSelectedStores((prev) =>
      prev.includes(shortName) ? prev.filter((s) => s !== shortName) : [...prev, shortName]
    );
  };

  return { selectedStores, toggleStore, storeFilterItems };
}
